import React from 'react';

const About = () => (
  <div className="about">
    <h2>About This Application</h2>
    <p>
      This app helps you stay productive by combining a task manager, a timer, and a live video feed to track your focus during study sessions.
    </p>
    <ul>
      <li>Add your tasks to the list.</li>
      <li>Use the timer to measure study sessions.</li>
      <li>Review statistics on your focus after each session.</li>
    </ul>
  </div>
);

export default About;
